import React from 'react';

export default function DarkModeToggle({ darkMode, onToggle }) {
    const handleClick = (e) => {
        e.preventDefault();
        e.stopPropagation();
        console.log('Dark mode toggle clicked, current mode:', darkMode);
        if (onToggle) {
            onToggle();
        }
    };

    return (
        <button
            type="button"
            onClick={handleClick}
            className="cs_dark_mode_toggle"
            aria-label="Toggle dark mode"
            title={darkMode ? 'Switch to Light Mode' : 'Switch to Dark Mode'}
        >
            {darkMode ? (
                // Sun icon for light mode
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <circle cx="10" cy="10" r="4" fill="currentColor" />
                    <path
                        d="M10 0V3M10 17V20M20 10H17M3 10H0M16.364 16.364L14.243 14.243M5.757 5.757L3.636 3.636M16.364 3.636L14.243 5.757M5.757 14.243L3.636 16.364"
                        stroke="currentColor"
                        strokeWidth="2"
                        strokeLinecap="round"
                    />
                </svg>
            ) : (
                // Moon icon for dark mode
                <svg
                    width="20"
                    height="20"
                    viewBox="0 0 20 20"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                >
                    <path
                        d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
                        fill="currentColor"
                    />
                </svg>
            )}
        </button>
    );
}
